/**
 * Header categories <details>: close on outside click / Escape; only one open at a time.
 */
function initHeaderCategoriesDropdowns() {
  const detailsList = Array.from(document.querySelectorAll('.header-categories-dropdown__details'));
  if (!detailsList.length) return;

  detailsList.forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      detailsList.forEach((other) => {
        if (other !== details) other.open = false;
      });
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Node)) return;
    detailsList.forEach((details) => {
      if (!details.open) return;
      if (details.contains(target)) return;
      details.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    detailsList.forEach((details) => {
      if (details.open) details.open = false;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderCategoriesDropdowns);
} else {
  initHeaderCategoriesDropdowns();
}
